<template>
  <div>
    <head>
      <title>Pay Now</title>
    </head>

    <body>
      <div class="wrapper">
        <BannerOne title="Pay Now" />

        <div class="content" v-if="loading">
          <h2 class="normal">{{ this.loadingmsg }}</h2>
        </div>
        <div class="content" v-if="!loading">
          <h2 class="normal">Make Payment For</h2>
          <h2 class="trans-id">#{{ this.cartId }}</h2>

          <div class="custom-button green" @click="handlePayment">Proceed</div>

          <!-- <h2 class="normal">Payment Token</h2>
          <h2 class="trans-id">{{ this.paymentToken }}</h2> -->
        </div>
        <!-- eo content -->
      </div>
      <!-- eo wrapper -->
    </body>
  </div>
</template>

<script>
import BannerOne from "../../components/BannerOne.vue";
import axios from "axios";
import { CartData } from "../../services/storage.service";
import router from "../../router";
import { mapActions } from "vuex";

export default {
  name: "PayNow",
  components: {
    BannerOne,
  },
  data() {
    return {
      cartId: 0,
      paymentToken: 0,
      loading: false,
      loadingmsg: "",
    };
  },
  created() {
    this.clearCart();
    this.cartId = this.$route.query.c;
    this.paymentToken = this.$route.query.t;
  },
  methods: {
    ...mapActions(["clearCart"]),

    async handlePayment() {
      this.loading = true;
      this.loadingmsg = "Please Wait, Starting payment process.";

      // const url = "https://manager.khaanpin.com/api/genpaydetails/";
      const url = "https://deus.khaanpin.com/om/genpaydetails/";


      await axios
        .post(url, {
          cart_id: this.cartId,
          payment_tok: this.paymentToken,
        })
        .then((response) => {
          if (response.data.error === false) {
            const DATA = response.data.data;
            CartData.setExtCartAmount(DATA.amount);
            CartData.setExtCardId(DATA.cart_id);

            router.push("/p/extpayment");
            // this.loading = false;
          } else {
            // console.log("Error", response.data.data);
            this.loadingmsg = "Error:" + response.data.data;
            setTimeout(() => {
              this.loading = false;
              this.loadingmsg = "";
            }, [2000]);
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

body {
  background: #fefefe;
}
.wrapper {
  text-align: center;
  font-family: sans-serif;
  margin-top: 20px;
  margin-bottom: 6%;
}
h2 {
  font-size: 14px;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin: 20px;
  color: #333;
}
.logo {
  width: 150px;
  margin-top: 40px;
}
.content {
  margin-top: 20px;
  align-items: center;
}

.type {
  font-size: 34px;
  letter-spacing: 14px;
  background: $brand-color;
  padding: 20px 60px;
  color: #fff;
  display: inline-block;
}
.trans-id {
  color: $brand-color;
  font-family: $main-font;
  font-size: 20px;
}
a {
  display: inline-block;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 5px;
  margin-top: 40px;
  color: #333;
}

.custom-button {
  height: 40px;
  width: 160px;
  margin: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &.green {
    background: #60b246;
    border-color: #60b246;
    &:hover {
      color: white;
    }
  }
  &.hide {
    display: none;
  }
}
</style>
